import React from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

import { CloseReopenCycle } from './CloseReopenCycle';
import {
  CloseOpenWrapper,
  TestCaseActionsWrapperStyled,
  TestCycleDetailsActionsStyled,
} from './TestCycleTestCasesListTab.styled';
import { AddTestCasesToCycleModal } from './addTestCasesToCycleModal';
import { TestCaseInCycleAssigneeFilter } from './testCasesInCycleList/TestCaseInCycleAssigneeFilter';
import { TestCaseInCycleSearchFilter } from './testCasesInCycleList/TestCaseInCycleSearchFilter';
import { TestCaseInCycleStatusFilter } from './testCasesInCycleList/TestCaseInCycleStatusFilter';
import { TestCaseInCycleTestTypeFilter } from './testCasesInCycleList/TestCaseInCycleTestTypeFilter';

export default function TestCycleDetailsActionsHeader(): JSX.Element {
  const showTestTypeFilter =
    StorageOfUniqueServices.get('LicenseService').isAdvanced;

  return (
    <TestCycleDetailsActionsStyled>
      <TestCaseActionsWrapperStyled>
        <AddTestCasesToCycleModal />
        {showTestTypeFilter && <TestCaseInCycleTestTypeFilter />}
        <TestCaseInCycleStatusFilter />
        <TestCaseInCycleAssigneeFilter />
        <TestCaseInCycleSearchFilter />
      </TestCaseActionsWrapperStyled>
      <CloseOpenWrapper>
        <CloseReopenCycle />
      </CloseOpenWrapper>
    </TestCycleDetailsActionsStyled>
  );
}
